import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { subscriptionActions } from '..';
import { authActions } from '../../auth';
import { HistoryState, SubscriptionActions } from '../types';

const initialHistoryState: HistoryState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const historyReducer: Reducer<typeof initialHistoryState, SubscriptionActions> = (
  state = initialHistoryState,
  action
) => {
  switch (action.type) {
    case getType(authActions.logoutAsync.success): {
      return initialHistoryState;
    }
    case getType(subscriptionActions.fetchSubscriptionHistoryAsync.request): {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }

    case getType(subscriptionActions.fetchSubscriptionHistoryAsync.success): {
      return {
        ...state,
        data: action.payload,
        isError: false,
        isPending: false
      };
    }

    case getType(subscriptionActions.fetchSubscriptionHistoryAsync.failure): {
      return {
        ...state,
        error: action.payload,
        isError: true,
        isPending: false
      };
    }

    default:
      return state;
  }
};

export default historyReducer;
